import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'Orders',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'order': models.Order,
      'shipment': models.Shipment,
      'cart': models.Cart,
      'payment': models.Payment
    }
  }

}
